export default class Bypass {
  flag = 'yes';
}
